import { ref } from 'vue';

import type { IFileDownloadResponse } from '~/types';

import {
  base64ToArrayBuffer,
  openFileInNewTab,
  setDownloadAnchor,
} from './fileUtilities';

const MIME = {
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  HTML: 'text/html',
  PDF: 'application/pdf',
};

export const useReportFiles = () => {
  const previewFile = ref<{
    id: string;
    file: File;
  } | null>(null);

  const filesById = ref<{
    [key: string]: IFileDownloadResponse;
  }>({});

  const _getActualFile = ({ file, name, type }: IFileDownloadResponse) => {
    const arrayBuffer = base64ToArrayBuffer(file);

    return new File([arrayBuffer], name, {
      type: type,
    });
  };

  const downloadReportFile = (
    id: string,
    cb?: () => Promise<IFileDownloadResponse>,
  ) => {
    if (id in filesById.value) {
      setDownloadAnchor(filesById.value[id]);

      return;
    }

    cb?.().then((data) => {
      filesById.value[id] = data;

      setDownloadAnchor(data);
    });
  };

  const previewReportFile = (
    id: string,
    cb: () => Promise<IFileDownloadResponse>,
  ) => {
    const setPreview = (data: IFileDownloadResponse) => {
      filesById.value[id] = data;

      if (data.type === MIME.XLSX) {
        previewFile.value = {
          id,
          file: _getActualFile(data),
        };
      } else {
        openFileInNewTab(data);
      }
    };

    if (id in filesById.value) {
      setPreview(filesById.value[id]);
      return;
    }

    cb().then(setPreview);
  };

  return {
    previewFile,
    filesById,

    previewReportFile,
    downloadReportFile,
  };
};
